import React, { FunctionComponent, useState } from 'react'
import { Card, Grid, Hidden } from '@material-ui/core'
import {
  SubtitleItemServicoFinanceiro,
  TitleItemServicoFinanceiro,
} from './styles'
import { AiOutlineArrowRight } from 'react-icons/all'
import { colors } from '../../../../../../../../shared/styles/colors'

interface ItemServiceFinanceiroProps {
  title: string
  subtitle: string
  icon: React.ReactNode
  onClick: () => void
  isNew?: boolean
}
const ItemServicoFinanceiro: FunctionComponent<ItemServiceFinanceiroProps> = ({
  title,
  subtitle,
  icon,
  onClick,
  isNew,
}) => {
  const [backgroundColor, setBackgroundColor] = useState('white')

  return (
    <Card
      onClick={onClick}
      elevation={1}
      onMouseOver={() => setBackgroundColor('#e3e3e3')}
      onMouseOut={() => setBackgroundColor(colors.white)}
      style={{
        backgroundColor,
        minHeight: 140,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        display: 'flex',
        padding: 8,
        margin: 8,
        maxHeight: 180,
        paddingLeft: 24,
      }}
    >
      <Grid
        container
        spacing={0}
        justifyContent={'center'}
        alignItems={'center'}
        alignContent={'center'}
      >
        <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
          <span>{icon}</span>
        </Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <TitleItemServicoFinanceiro>
            {title}
            {isNew ? (
              <Hidden smDown>
                <span
                  style={{
                    backgroundColor: '#24A95D',
                    color: 'white',
                    padding: 6,
                    borderRadius: 4,
                    fontSize: 12,
                    fontWeight: 600,
                    marginLeft: 12,
                  }}
                >
                  Novo
                </span>
              </Hidden>
            ) : (
              <></>
            )}
          </TitleItemServicoFinanceiro>
        </Grid>
        <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
          <AiOutlineArrowRight size={16} color={colors.green} />
        </Grid>
        <Grid xs={12} sm={12} md={1} lg={1} xl={1} />
        <Grid
          item
          xs={12}
          sm={12}
          md={10}
          lg={10}
          xl={10}
          style={{
            textAlign: 'left',
          }}
        >
          <SubtitleItemServicoFinanceiro>
            {subtitle}
          </SubtitleItemServicoFinanceiro>
        </Grid>
        <Grid item xs={12} sm={12} md={1} lg={1} xl={1} />
      </Grid>
    </Card>
  )
}

export default ItemServicoFinanceiro
